import { RegistrationV2State, TwikeyResponseStatus, TwikeyValidationError } from "features/registration-v2/registrationV2Slice";
import { faCheckCircle, faCircleQuestion, faCircleXmark, faPrint, faTimesCircle, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { Fragment } from "react/jsx-runtime";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoadingSpinner from "../LoadingSpinner";
import { ContactSupportLink } from "./TeamleaderSubscriptionStatus";


// https://www.twikey.com/api/#thank-you-page


export type TwikeyStatusContent = {
    title: string,
    description: string,
    icon: IconDefinition,
    color: string
}

export const getTwikeyStatusContent = (twikeyStatus: TwikeyResponseStatus | undefined): TwikeyStatusContent | undefined => {
    if (twikeyStatus) {
        switch (twikeyStatus) {
            case 'ok':
                return {
                    title: 'TWIKEY_MANDATE_SIGNED_STATUS_OK_TITLE',
                    description: 'TWIKEY_MANDATE_SIGNED_STATUS_OK_DESCRIPTION',
                    icon: faCheckCircle,
                    color: '#35D38C'
                }
            case 'cancel':
                return {
                    title: 'TWIKEY_MANDATE_SIGNED_STATUS_CANCEL_TITLE',
                    description: 'TWIKEY_MANDATE_SIGNED_STATUS_CANCEL_DESCRIPTION',
                    icon: faCircleXmark,
                    color: '#ff8c00'
                }
            case 'fail':
                return {
                    title: 'TWIKEY_MANDATE_SIGNED_STATUS_FAIL_TITLE',
                    description: 'TWIKEY_MANDATE_SIGNED_STATUS_FAIL_DESCRIPTION',
                    icon: faCircleXmark,
                    color: '#D34B35'
                }
            case 'pending':
                return {
                    title: 'TWIKEY_MANDATE_SIGNED_STATUS_PENDING_TITLE',
                    description: 'TWIKEY_MANDATE_SIGNED_STATUS_PENDING_DESCRIPTION',
                    icon: faCircleQuestion,
                    color: '#033061'
                }
            case 'print':
                return {
                    title: 'TWIKEY_MANDATE_SIGNED_STATUS_PRINT_TITLE',
                    description: 'TWIKEY_MANDATE_SIGNED_STATUS_PRINT_DESCRIPTION',
                    icon: faPrint,
                    color: '#033061'
                }
        }
    }
}

export const TwikeySigningError = ({ twikeySigningError }: { twikeySigningError: TwikeyValidationError }) => (
    <div className="error-box" style={{ marginTop: '1em' }}>
        {twikeySigningError.errorType}
        {twikeySigningError.details && (typeof twikeySigningError.details === "string") && (
            <span>&nbsp;-&nbsp;{twikeySigningError.details}</span>
        )}
    </div>
)

export const TwikeySigningStatus = (props: Props) => {

    const { processingSigning, twikeyStatus, twikeySignatureIsValid, twikeySigningError } = props.registration;
    const statusContent = getTwikeyStatusContent(twikeyStatus as TwikeyResponseStatus);

    if (processingSigning) {
        return <LoadingSpinner message={<FormattedMessage id="REGISTRATION_VERIFYING_TRANSACTION" />} />
    }

    if (props.invalidQueryParams === true) {
        return (
            <p className="red">
                <FormattedMessage id='REGISTRATION_TWIKEY_SIGNING_ERROR_COULD_NOT_VERIFY' />
            </p>
        );
    }

    if (twikeySignatureIsValid && twikeyStatus) {
        return (
            <Fragment>
                <div className="flex">
                    <FontAwesomeIcon icon={statusContent?.icon!} size="2xl" color={statusContent?.color} />
                    <h3 className="bold-title" style={{ marginLeft: '1em', color: statusContent?.color }}>
                        <FormattedMessage id={statusContent?.title} />
                    </h3>
                </div>
                <p style={{ marginTop: '0.5em', color: statusContent?.color }}>
                    <FormattedMessage id={statusContent?.description} />
                </p>
            </Fragment>
        )
    }

    if (twikeySigningError) {
        return (
            <Fragment>
                <div className="flex">
                    <FontAwesomeIcon icon={faTimesCircle} size="2xl" color="#EF6F6C" />
                    <h3 className="bold-title red" style={{ marginLeft: '1em' }}>
                        <FormattedMessage id="REGISTRATION_TWIKEY_SIGNING_FAILED_TITLE" />
                    </h3>
                </div>
                <p className="red" style={{ marginTop: '0.5em' }}>
                    <FormattedMessage id="REGISTRATION_TWIKEY_SIGNING_FAILED_DESCRIPTION" />
                </p>
                <TwikeySigningError twikeySigningError={twikeySigningError} />
                <div className="center">
                    <ContactSupportLink />
                </div>
            </Fragment>
        )
    }
}

type Props = { invalidQueryParams?: boolean, registration: RegistrationV2State }
